export default __webpack_public_path__ + "static/media/cart1.2129ce12.jpg";